import {LayerImagery, LayerLoadType, MapperViewer} from '../../types';

export class ZiparuLayer implements LayerImagery {

  id = 'ziparu';
  name = 'ZM inondation';
  active = true;
  imageryLayer = new Cesium.ImageryLayer(new Cesium.WebMapServiceImageryProvider({
    url: 'https://mapserver-v2.predictservices.ws/wms?',
    layers: 'zone_inondable_cote_d_ivoire_wms',
    parameters: {
      service: 'WMS',
      version: '1.3.0',
      request: 'GetMap',
      styles: '',
      format: 'image/png',
      transparent: true,
      width: 512,
      height: 512
    },
    tilingScheme: new Cesium.GeographicTilingScheme(),
    maximumLevel: 18,
  }));
  loadType: LayerLoadType;
  viewer: MapperViewer;
  showLabel = false;

  /* Custom properties */
  initialize(viewer: MapperViewer): void {
    this.viewer = viewer;
    viewer.imageryLayers.add(this.imageryLayer);
  }

  remove(): void {
    this.viewer.imageryLayers.remove(this.imageryLayer, false);
  }

  loadData(): void {}

  setActive(active: boolean): void {
    this.active = active;
    this.imageryLayer.show = active;
  }

  onAfterPrint(): void {
  }

  onBeforePrint(): void {
  }
}
